/* Wolpic · Previsualizador de cuadros
   - Recibe las fotos que el cliente sube con Uploadly (evento uploadly:upload-complete).
   - Las coloca dentro de los marcos del producto, a escala real (cm).
   - El cliente puede cambiar qué foto va en cada cuadro (arrastrar o tocar), el color del marco y el margen blanco.
   - Guarda la distribución en el pedido como propiedades de la línea. */
(function () {
  'use strict';

  var root = document.querySelector('[data-wp-fp]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  var DATA = JSON.parse(root.querySelector('[data-wp-fp-data]').textContent);
  var PRODUCT = DATA.product;
  var INLINE = root.getAttribute('data-mode') === 'inline';   // plantilla product.personalizador: la ficha es el personalizador
  var PROFILE_CM = 1.8;           // ancho del listón del marco
  var MARGINS = [
    { pct: 0, key: 'sin', label: 'Sin margen', hint: 'La foto llena el marco' },
    { pct: 10, key: 'delgado', label: 'Delgado', hint: '10 %' },
    { pct: 30, key: 'mediano', label: 'Mediano', hint: '30 %' },
    { pct: 50, key: 'ancho', label: 'Ancho', hint: '50 %' }
  ];
  var COLOR_NAMES = { negro: 'Negro', blanco: 'Blanco', madera: 'Madera natural', nogal: 'Nogal', none: 'Sin marco' };
  var TITLE = String(PRODUCT.title || '');
  var DESC = String(PRODUCT.description || '').replace(/<[^>]*>/g, ' ').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ');
  var FRAMELESS = /sin marco|forex/i.test(TITLE);
  var TOUCH = !!(window.matchMedia && window.matchMedia('(hover: none)').matches);

  var state = {
    files: [],          // [{uuid, name, url}]
    assign: [],         // frameIndex -> fileIndex | null
    margin: null,       // pct elegido por el cliente
    view: (DATA.layout && DATA.layout.room) ? 'room' : 'set',
    selected: null,     // {type:'file'|'frame', idx}
    saved: false,
    edits: [],          // frameIndex -> ajustes de la foto (recorte, giro, filtros…) con u = uuid de la foto
    prints: {}          // frameIndex -> {sig, url} archivo listo para imprimir
  };

  /* ---------- utilidades ---------- */
  function $(s, el) { return (el || document).querySelector(s); }
  function $$(s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); }
  function h(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function fmtCm(n) { return (Math.round(n * 10) / 10).toString().replace('.', ','); }
  function money(cents) {
    var f = String(DATA.money_format || 'S/ {{amount}}').replace(/<[^>]*>/g, ''), n = Number(cents) / 100;
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return Math.round(n).toString();
      if (k === 'amount_with_comma_separator') return n.toFixed(2).replace('.', ',');
      return n.toFixed(2);
    });
  }

  function productForm() {
    return $('form.product-form[action*="/cart/add"]') || $('form[action*="/cart/add"]:not(#sticky-product-form)');
  }
  function currentVariant() {
    var f = productForm();
    var input = f && f.querySelector('[name="id"]');
    var id = input ? String(input.value) : '';
    for (var i = 0; i < PRODUCT.variants.length; i++) if (String(PRODUCT.variants[i].id) === id) return PRODUCT.variants[i];
    return PRODUCT.variants[0];
  }

  /* ---------- color y borde según la variante ---------- */
  var COLOR_KEYS = [['nogal', 'nogal'], ['negro', 'negro'], ['blanco', 'blanco'], ['madera', 'madera'], ['natural', 'madera']];
  function colorFromValue(val) {
    var s = String(val || '').toLowerCase();
    if (s.indexOf('blanco y negro') > -1) return null;
    for (var i = 0; i < COLOR_KEYS.length; i++) if (s.indexOf(COLOR_KEYS[i][0]) > -1) return COLOR_KEYS[i][1];
    return null;
  }
  function colorOptionIndex() {
    for (var i = 0; i < PRODUCT.options.length; i++) {
      var name = String(PRODUCT.options[i].name || PRODUCT.options[i]).toLowerCase();
      if (/color|marco|modelo/.test(name)) {
        var vals = PRODUCT.variants.map(function (v) { return v.options[i]; });
        if (vals.some(colorFromValue)) return i;
      }
    }
    return -1;
  }
  var COLOR_IDX = colorOptionIndex();
  function frameColor(v) {
    if (FRAMELESS || v.options.some(function (o) { return /sin marco/i.test(String(o)); })) return 'none';
    if (COLOR_IDX > -1) { var c = colorFromValue(v.options[COLOR_IDX]); if (c) return c; }
    if (/madera/i.test(TITLE)) return 'madera';
    return DATA.defaultColor || 'negro';
  }
  /* efecto "Blanco y Negro" de la variante: las fotos se muestran en escala de grises */
  function isBW(v) { return v.options.some(function (o) { return /blanco y negro|b\s*\/\s*n\b/i.test(String(o)); }); }
  function availableColors() {
    if (COLOR_IDX < 0) return [];
    var seen = {}, out = [];
    PRODUCT.variants.forEach(function (v) {
      var val = v.options[COLOR_IDX], c = colorFromValue(val), key = EMB ? c : val;
      if (c && !seen[key]) { seen[key] = 1; out.push({ value: val, color: c }); }
    });
    return out;
  }
  function bordeOptionIndex() {
    for (var i = 0; i < PRODUCT.options.length; i++) {
      var vals = PRODUCT.variants.map(function (v) { return String(v.options[i]); });
      if (vals.some(function (x) { return /sin borde|con borde/i.test(x); })) return i;
    }
    return -1;
  }
  var BORDE_IDX = bordeOptionIndex();
  /* algunos productos llevan el borde dentro del color: "Negro" / "Negro + borde" */
  var EMB = BORDE_IDX < 0 && COLOR_IDX > -1 && PRODUCT.variants.some(function (v) { return /\+\s*borde/i.test(String(v.options[COLOR_IDX])); });
  function colorValueFor(color, borde) {
    for (var i = 0; i < PRODUCT.variants.length; i++) {
      var val = String(PRODUCT.variants[i].options[COLOR_IDX]);
      if (colorFromValue(val) === color && /\+\s*borde/i.test(val) === !!borde) return PRODUCT.variants[i].options[COLOR_IDX];
    }
    return null;
  }
  function optionValue(idx, re) {
    for (var i = 0; i < PRODUCT.variants.length; i++) if (re.test(String(PRODUCT.variants[i].options[idx]))) return PRODUCT.variants[i].options[idx];
    return null;
  }
  function bordeFrom(v) {
    if (EMB) return /\+\s*borde/i.test(String(v.options[COLOR_IDX]));
    for (var i = 0; i < v.options.length; i++) {
      var s = String(v.options[i]).toLowerCase();
      if (s.indexOf('sin borde') > -1) return false;
      if (s.indexOf('con borde') > -1 || s.indexOf('+ borde') > -1) return true;
    }
    return null;
  }

  /* ---------- plano de marcos ---------- */
  function sizeFrom(v) {
    for (var i = 0; i < v.options.length; i++) {
      var m = String(v.options[i]).match(/(\d+(?:[.,]\d+)?)\s*x\s*(\d+(?:[.,]\d+)?)/i);
      if (m) return { w: parseFloat(m[1].replace(',', '.')), h: parseFloat(m[2].replace(',', '.')) };
    }
    return null;
  }
  function autoLayout(n, w, hgt) {
    var cols = n <= 3 ? n : n === 4 ? 2 : n <= 9 ? 3 : n <= 12 ? 4 : 5, gap = 4, rows = Math.ceil(n / cols);
    var W = cols * w + (cols - 1) * gap, H = rows * hgt + (rows - 1) * gap, frames = [];
    for (var r = 0; r < rows; r++) {
      var count = Math.min(cols, n - r * cols), off = (W - (count * w + (count - 1) * gap)) / 2;
      for (var c = 0; c < count; c++) frames.push({ x: off + c * (w + gap), y: r * (hgt + gap), w: w, h: hgt });
    }
    return { w: W, h: H, frames: frames };
  }
  function num(x) { return parseFloat(String(x).replace(',', '.')); }
  function titleSize() {
    var m = TITLE.match(/(\d+(?:[.,]\d+)?)\s*x\s*(\d+(?:[.,]\d+)?)\s*cm/i);
    if (m) return { w: num(m[1]), h: num(m[2]) };
    if (/\bA4\b/.test(TITLE)) return { w: 21, h: 29.7 };
    return null;
  }
  /* cantidad de cuadros según la variante: "3 und", "x9 und", "12 cuadros" */
  function packCount(v) {
    for (var i = 0; i < v.options.length; i++) {
      var m = String(v.options[i]).match(/^\s*x?\s*(\d+)\s*(und|unid|uds|unidades|cuadros?)\b/i);
      if (m) return +m[1];
    }
    return 0;
  }
  function titleCount() {
    var m = TITLE.match(/(?:pack|set|paquete)\s*(?:de\s*)?(\d+)/i) || TITLE.match(/(\d+)\s*cuadros/i);
    return m ? +m[1] : 0;
  }
  /* composición escrita en la descripción: "2 cuadros de 20x30cm, 1 cuadro de 40x60cm…" */
  function descFrames() {
    var re = /(\d+)\s*cuadros?\s*(?:de\s*)?(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*cm/gi, m, out = [];
    while ((m = re.exec(DESC))) for (var k = 0; k < +m[1] && out.length < 40; k++) out.push({ w: num(m[2]), h: num(m[3]) });
    return out;
  }
  /* arma un muro equilibrado: los cuadros chicos se apilan en columnas y el más grande queda al centro */
  function galleryLayout(items) {
    var same = items.every(function (f) { return f.w === items[0].w && f.h === items[0].h; });
    if (same) return autoLayout(items.length, items[0].w, items[0].h);
    var gap = 4, list = items.slice().sort(function (a, b) { return b.w * b.h - a.w * a.h; });
    var Hmax = Math.max.apply(null, list.map(function (f) { return f.h; })), used = [], cols = [];
    list.forEach(function (f, i) {
      if (used[i]) return; used[i] = true;
      var col = [f], hs = f.h, w = f.w;
      if (f.h <= Hmax * 0.62) list.forEach(function (g, j) {
        if (used[j] || hs + gap + g.h > Hmax * 1.06 || Math.abs(g.w - f.w) > 12) return;
        used[j] = true; col.push(g); hs += gap + g.h; w = Math.max(w, g.w);
      });
      cols.push({ frames: col, w: w, h: hs });
    });
    var order = []; cols.forEach(function (c, k) { if (k % 2) order.unshift(c); else order.push(c); });
    var H = Math.max.apply(null, order.map(function (c) { return c.h; })), x = 0, frames = [];
    order.forEach(function (c) {
      var y = (H - c.h) / 2;
      c.frames.forEach(function (f) { frames.push({ x: x + (c.w - f.w) / 2, y: y, w: f.w, h: f.h }); y += f.h + gap; });
      x += c.w + gap;
    });
    return { w: x - gap, h: H, frames: frames };
  }
  function singleLayout(s) { return { w: s.w, h: s.h, frames: [{ x: 0, y: 0, w: s.w, h: s.h }] }; }
  /* productos sin plano propio: se arma solo con la variante, el título o la descripción */
  function dynamicLayout(v) {
    var size = sizeFrom(v) || titleSize() || { w: 20, h: 20 };
    var n = packCount(v);
    if (n > 1) return autoLayout(n, size.w, size.h);
    if (n === 1) return singleLayout(size);
    var d = descFrames();
    if (d.length > 1) return galleryLayout(d);
    n = titleCount();
    if (n > 1) return autoLayout(n, size.w, size.h);
    return singleLayout(size);
  }
  function layoutFor(v) {
    var L = DATA.layout;
    if (!L) return dynamicLayout(v);
    if (L.frames) return L;
    if (L.auto) return autoLayout(L.auto.n, L.auto.w, L.auto.h);
    if (L.single) return singleLayout(sizeFrom(v) || { w: L.single.w || 20, h: L.single.h || 30 });
    return dynamicLayout(v);
  }
  if (!layoutFor(currentVariant())) return;
  function frameLabel(f, i, L) {
    if (f.label) return f.label;
    return L.frames.length > 1 ? 'Cuadro ' + (i + 1) : 'Tu cuadro';
  }

  /* margen: el cliente elige qué % del área del marco ocupa el blanco; el ancho es igual en los 4 lados */
  function matWidth(W, H, pct) {
    var m = pct / 100; if (m <= 0) return 0;
    var s = W + H; return (s - Math.sqrt(s * s - 4 * m * W * H)) / 4;
  }
  function effectiveMargin(v) {
    var b = bordeFrom(v);
    if (b === false) return 0;
    if (state.margin != null && !(b === true && state.margin === 0)) return state.margin;
    return b === true ? 30 : 0;
  }

  /* ---------- fotos de Uploadly ---------- */
  /* Uploadcare: se conserva el recorte o la edición que el cliente hizo en Uploadly (-/crop/…, -/rotate/…) */
  function ucParts(u) {
    var m = String(u || '').match(/^(https?:\/\/[^/]*(?:ucarecdn|ucarecd\.net)[^/]*\/[0-9a-f-]{36}\/)(.*)$/i);
    if (!m) return null;
    var mods = (m[2] || '').replace(/-\/(preview|resize|scale_crop|quality|format|progressive|stretch)\/[^/]*\/?/g, '').replace(/^\/+/, '');
    if (mods && mods.slice(-1) !== '/') mods += '/';
    return { base: m[1], mods: mods };
  }
  function photoUrl(file, size) {
    var p = ucParts(file.url);
    if (p) return p.base + p.mods + '-/preview/' + size + 'x' + size + '/-/quality/smart/';
    return file.url || '';
  }
  function editedUrl(file) { var p = ucParts(file.url); return p && p.mods ? p.base + p.mods : ''; }

  /* ---------- ajustes de cada foto (editor compartido wp-photo-edit.js) ---------- */
  function PE() { return window.WPEdit || null; }
  function editFor(i) {
    var k = state.assign[i], file = k != null ? state.files[k] : null, e = state.edits[i];
    return file && e && e.u === file.uuid ? e : null;
  }
  function isEdited(i) { var W = PE(), e = editFor(i); return !!(W && e && W.isSet(e)); }
  /* medida de la foto visible dentro del marco (sin listón ni margen blanco), en cm */
  function openingCm(f, v) {
    var color = frameColor(v), prof = color === 'none' ? 0 : Math.min(PROFILE_CM, Math.min(f.w, f.h) * 0.12);
    var iw = f.w - 2 * prof, ih = f.h - 2 * prof, m = matWidth(iw, ih, effectiveMargin(v));
    return { w: Math.max(1, iw - 2 * m), h: Math.max(1, ih - 2 * m) };
  }
  function printSig(i) {
    var W = PE(), k = state.assign[i], file = k != null ? state.files[k] : null, v = currentVariant(), L = layoutFor(v);
    if (!W || !file || !L || !L.frames[i]) return '';
    var cm = openingCm(L.frames[i], v);
    return [file.uuid, JSON.stringify(W.norm(editFor(i) || {})), cm.w.toFixed(2), cm.h.toFixed(2)].join('|');
  }
  /* contenido de la foto dentro de un marco: imagen con sus ajustes + número + botón Editar */
  function photoInner(file, k, i, size, boxPx) {
    var W = PE();
    var num = '<span class="wpfp-num">' + (k + 1) + '</span>';
    if (!W) return { bg: photoUrl(file, size), html: num };
    var small = boxPx < 110;
    return { bg: '', html: W.imgHtml(photoUrl(file, size), editFor(i) || {}, '', false) + num +
      '<button type="button" class="wpx-chip' + (small ? ' is-icon' : '') + '" data-edit="' + i + '" aria-label="Editar la foto del cuadro ' + (i + 1) + '">' + W.ICON.edit + (small ? '' : 'Editar') + '</button>' };
  }
  function openFrameEditor(i) {
    var W = PE(), k = state.assign[i], file = k != null ? state.files[k] : null;
    if (!W || !file) return;
    var v = currentVariant(), L = layoutFor(v), f = L && L.frames[i]; if (!f) return;
    var cm = openingCm(f, v), uuid = file.uuid;
    W.open({
      src: photoUrl(file, 2000), aspect: cm.w / cm.h, edit: editFor(i) || {}, cm: cm, info: W.info(file.url),
      title: frameLabel(f, i, L) + ' · ' + fmtCm(f.w) + '×' + fmtCm(f.h) + ' cm',
      subtitle: 'Foto ' + (k + 1) + ' · así quedará impresa', base: isBW(v) ? 'grayscale(1)' : '',
      onDone: function (e) {
        var kk = state.assign[i]; if (kk == null || !state.files[kk] || state.files[kk].uuid !== uuid) return;
        e.u = uuid; state.edits[i] = e; state.saved = false; state.selected = { type: 'frame', idx: i };
        writeProperties(); renderAll(); updateCta();
      }
    });
  }
  function swapEdits(a, b) { var t = state.edits[a]; state.edits[a] = state.edits[b]; state.edits[b] = t; }
  /* aviso de baja resolución: píxeles reales de la foto para el tamaño del marco */
  function markQuality() {
    var W = PE(); if (!W) return;
    var v = currentVariant(), L = layoutFor(v); if (!L) return;
    L.frames.forEach(function (f, i) {
      var k = state.assign[i], file = k != null ? state.files[k] : null; if (!file) return;
      W.info(file.url).then(function (inf) {
        if (!inf || state.assign[i] !== k) return;
        var cm = openingCm(f, currentVariant()), ql = W.quality(editFor(i) || {}, cm.w / cm.h, inf, cm);
        $$('.wpfp-frame[data-frame="' + i + '"] .wpfp-photo', modal).forEach(function (ph) {
          var old = ph.querySelector('.wpx-lowres'); if (old) old.remove();
          if (ql && ql.level === 'baja') { var b = h('span', 'wpx-lowres', 'Baja resolución'); b.title = 'Esta foto se verá pixelada a este tamaño (' + ql.dpi + ' ppp). Usa menos zoom u otra foto.'; ph.appendChild(b); }
        });
      });
    });
  }
  /* texto para el pedido: número de foto (igual que "Carga tus fotos N" de Uploadly), nombre si es legible y link directo */
  function fileLabel(file, k) {
    var name = file.name && !/^[0-9a-f-]{36}\.\w+$/i.test(file.name) ? ' – ' + file.name : '';
    var ed = editedUrl(file);
    return 'Foto ' + (k + 1) + name + (file.link ? ' · ' + file.link : '') + (ed ? ' · recortada por el cliente: ' + ed : '');
  }
  function setFiles(list) {
    var old = state.files.map(function (f) { return f.uuid; });
    state.files = list.filter(function (f) { return f && f.url; });
    // conservar asignaciones por uuid, rellenar huecos con fotos sin usar
    var L = layoutFor(currentVariant()), n = L ? L.frames.length : 0, next = [];
    for (var i = 0; i < n; i++) {
      var prevIdx = state.assign[i], prevUuid = prevIdx != null ? old[prevIdx] : null, ni = null;
      if (prevUuid) state.files.forEach(function (f, k) { if (f.uuid === prevUuid) ni = k; });
      next[i] = ni;
    }
    state.files.forEach(function (f, k) {
      if (next.indexOf(k) > -1) return;
      var empty = next.indexOf(null);
      if (empty > -1) next[empty] = k;
    });
    state.assign = next;
  }
  function filesFromDom() {
    // respaldo: si las fotos se subieron antes de que cargue este script
    var out = [];
    $$('[data-img-id]').forEach(function (el) {
      var uuid = el.getAttribute('data-img-id');
      if (!uuid || out.some(function (f) { return f.uuid === uuid; })) return;
      var inp = el.querySelector('input[name^="properties["]');
      out.push({ uuid: uuid, name: '', url: (inp && inp.getAttribute('data-cdn')) || 'https://ucarecdn.com/' + uuid + '/', link: (inp && inp.value) || '' });
    });
    return out;
  }
  /* lista completa de fotos: la del evento, completada con las que Uploadly ya tiene en la página */
  function mergeFiles(evt) {
    var dom = filesFromDom(); if (dom.length < evt.length) return evt;
    var by = {}; evt.forEach(function (f) { by[f.uuid] = f; });
    return dom.map(function (f) { var x = by[f.uuid]; return x ? { uuid: f.uuid, name: x.name, url: x.url || f.url, link: x.link || f.link } : f; });
  }
  document.addEventListener('uploadly:upload-complete', function (e) {
    var d = e.detail || {};
    setFiles(mergeFiles((d.files || []).map(function (f) { return { uuid: f.uuid, name: f.name, url: f.cdnUrl || f.uploadlyUrl, link: f.uploadlyUrl || f.cdnUrl || '' }; })));
    state.saved = false;
    writeProperties();
    renderAll();
    updateCta();
  });
  function openUploader() {
    var field = window.UPLOADCARE_FIELD, d = window.UPLOADCARE_DATA && window.UPLOADCARE_DATA[field];
    try {
      if (d) { if (d.activate) d.activate(); if (d.widget && d.widget.openDialog) { d.widget.openDialog(); return; } }
    } catch (err) {}
    var btn = $('[id*="uploadly_file_upload"] button, [id*="uploadly_file_upload"] [role="button"]');
    if (btn) btn.click();
  }
  function maxFiles() {
    var field = window.UPLOADCARE_FIELD, d = window.UPLOADCARE_DATA && window.UPLOADCARE_DATA[field];
    return d && d.maximumFiles ? Number(d.maximumFiles) : null;
  }

  /* ---------- sincronizar color y estilo con el selector del tema ---------- */
  function chooseOption(idx, value) {
    var group = $('.product-option-group[data-option-index="' + idx + '"]');
    if (!group || value == null) return;
    $$('[data-value]', group).forEach(function (b) { if (b.getAttribute('data-value') === value) b.click(); });
    setTimeout(function () { renderAll(); writeProperties(); updateCta(); }, 60);
  }
  function chooseColor(value) { chooseOption(COLOR_IDX, value); }

  /* ---------- propiedades del pedido ---------- */
  function writeProperties() {
    var f = productForm(); if (!f) return;
    $$('[data-wpfp-prop]', f).forEach(function (n) { n.remove(); });
    if (!state.files.length) return;
    var v = currentVariant(), L = layoutFor(v); if (!L) return;
    function add(name, val) {
      var i = document.createElement('input');
      i.type = 'hidden'; i.name = 'properties[' + name + ']'; i.value = val; i.setAttribute('data-wpfp-prop', '1');
      f.appendChild(i);
    }
    L.frames.forEach(function (fr, i) {
      var k = state.assign[i], file = k != null ? state.files[k] : null;
      var where = frameLabel(fr, i, L) + (fr.label ? '' : ' (' + fmtCm(fr.w) + 'x' + fmtCm(fr.h) + ')');
      add('Cuadro ' + (i + 1) + ' · ' + where, file ? fileLabel(file, k) + (isEdited(i) ? ' · ajustada por el cliente: ' + PE().describe(editFor(i)) : '') : 'Sin foto asignada');
      var pr = state.prints[i];
      if (file && isEdited(i) && pr && pr.url && pr.sig === printSig(i)) add('Cuadro ' + (i + 1) + ' · foto lista para imprimir', pr.url);
    });
    var m = effectiveMargin(v);
    if (bordeFrom(v) !== false) add('Margen blanco', m ? (labelForMargin(m) + ' (' + m + ' %)') : 'Sin margen');
    if (state.preview && state.preview.url && state.preview.sig === captureSig()) add('Vista previa del cliente', state.preview.url);
  }
  function labelForMargin(p) { for (var i = 0; i < MARGINS.length; i++) if (MARGINS[i].pct === p) return MARGINS[i].label; return p + ' %'; }

  function isSaved() { return !!state.saved && state.savedSig === captureSig(); }

  /* ---------- CTA en la ficha ---------- */
  var cta = h('div', 'wpfp-cta');
  function updateCta() {
    var n = state.files.length, L = layoutFor(currentVariant()), total = L ? L.frames.length : 0;
    var used = state.assign.filter(function (x) { return x != null; }).length;
    cta.innerHTML =
      '<div class="wpfp-cta__art" aria-hidden="true"><span></span><span></span><span></span></div>' +
      '<div class="wpfp-cta__body">' +
        '<strong>' + (n ? 'Mira cómo quedan tus fotos' : 'Diseña ' + (total > 1 ? 'tus cuadros' : 'tu cuadro') + ' con tus fotos') + '</strong>' +
        '<small>' + (n
          ? (isSaved() ? '✓ Vista previa guardada · ' + used + ' de ' + total + ' cuadros con foto' : used + ' de ' + total + ' cuadros con foto · elige el orden y el margen')
          : 'Sube tus fotos, míralas en la pared y agrégalas al carrito') + '</small>' +
      '</div>' +
      '<button type="button" class="wpfp-cta__btn">' + (isSaved() ? 'Editar' : (n ? 'Previsualizar' : 'Empezar')) + '</button>';
    $('.wpfp-cta__btn', cta).addEventListener('click', openModal);
    if (typeof relabel === 'function') relabel();
  }

  /* ---------- modal ---------- */
  var modal = h('div', 'wpfp-modal');
  modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true'); modal.setAttribute('aria-label', 'Vista previa de tus cuadros');
  modal.innerHTML =
    '<div class="wpfp-modal__backdrop" data-close></div>' +
    '<div class="wpfp-modal__panel">' +
      '<header class="wpfp-head">' +
        '<div><p class="wpfp-eyebrow">Vista previa</p><h2 class="wpfp-title">Así quedarán tus cuadros</h2></div>' +
        '<span class="wpfp-price"></span>' +
        '<button type="button" class="wpfp-x" data-close aria-label="Cerrar">&times;</button>' +
      '</header>' +
      '<div class="wpfp-body">' +
        '<div class="wpfp-stage-wrap">' +
          '<div class="wpfp-views" role="tablist"></div>' +
          '<div class="wpfp-stage"><div class="wpfp-room"></div><div class="wpfp-comp"></div><div class="wpfp-single"></div></div>' +
          '<div class="wpfp-adjbar" hidden></div>' +
          '<p class="wpfp-measure"></p>' +
        '</div>' +
        '<aside class="wpfp-side">' +
          '<section class="wpfp-block wpfp-block--opts" hidden><h3>Tu pedido</h3><div class="wpfp-opts"></div></section>' +
          '<section class="wpfp-block"><h3>Tus fotos</h3><p class="wpfp-help"></p><div class="wpfp-tray"></div></section>' +
          '<section class="wpfp-block wpfp-block--color"><h3>Color del marco</h3><div class="wpfp-colors"></div></section>' +
          '<section class="wpfp-block wpfp-block--margin"><h3>Margen blanco</h3><div class="wpfp-margins"></div><p class="wpfp-note wpfp-margin-note"></p></section>' +
        '</aside>' +
      '</div>' +
      '<footer class="wpfp-foot">' +
        '<p class="wpfp-status"></p>' +
        '<div class="wpfp-foot__btns"><button type="button" class="wpfp-skip" hidden>Continuar sin fotos</button><button type="button" class="wpfp-done">Listo, agregar al carrito</button></div>' +
      '</footer>' +
    '</div>' +
    '<div class="wpfp-ghost" aria-hidden="true"></div>';

  var closeT = null, lastFocus = null;
  function openModal() {
    if (!state.files.length) { var dom = filesFromDom(); if (dom.length) setFiles(dom); }
    if (INLINE) { renderAll(); if (modal.scrollIntoView) modal.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
    clearTimeout(closeT);
    lastFocus = document.activeElement;
    document.body.appendChild(modal);
    document.documentElement.classList.add('wpfp-lock');
    requestAnimationFrame(function () { modal.classList.add('is-open'); renderAll(); var x = $('.wpfp-x', modal); if (x) try { x.focus({ preventScroll: true }); } catch (e) {} });
  }
  function closeModal() {
    if (INLINE) return;
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('wpfp-lock');
    closeT = setTimeout(function () { if (modal.parentNode) modal.parentNode.removeChild(modal); }, 220);
    if (lastFocus && lastFocus.focus && document.contains(lastFocus)) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
  }
  modal.addEventListener('click', function (e) {
    if (e.target.closest('[data-close]')) { closeModal(); return; }
    var ed = e.target.closest('[data-edit]');
    if (ed) { e.preventDefault(); e.stopPropagation(); openFrameEditor(+ed.getAttribute('data-edit')); return; }
    if (e.target.closest('[data-unselect]')) { state.selected = null; renderAll(); }
  });
  function uploaderOpen() { return !!document.querySelector('.uploadcare--dialog_status_active, .uploadcare--dialog:not([hidden]) .uploadcare--panel, .uploadcare-dialog'); }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('is-open') && !uploaderOpen()) closeModal(); });
  modal.addEventListener('keydown', function (e) {   // Tab no sale del personalizador mientras está abierto
    if (e.key !== 'Tab' || INLINE || uploaderOpen()) return;
    var list = $$('button:not([disabled]), [tabindex="0"], a[href], input, select, textarea', modal).filter(function (el) { return el.offsetParent !== null; });
    if (!list.length) return;
    var first = list[0], last = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  /* botón final: guarda la vista previa en la línea del pedido y agrega al carrito con el botón del tema */
  var doneBtn = $('.wpfp-done', modal), adding = false;
  function updateDone() {
    if (adding) return;
    doneBtn.textContent = state.files.length ? 'Listo, agregar al carrito · ' + money(currentVariant().price) : 'Subir mis fotos';
    if (skipBtn) skipBtn.hidden = !!state.files.length;
  }
  /* "Continuar sin fotos": agrega al carrito sin fotos (las envía por WhatsApp después de comprar), con un aviso antes */
  var skipBtn = $('.wpfp-skip', modal);
  skipBtn.addEventListener('click', function () {
    if (adding || state.files.length) return;
    var C = window.WPCapture, f = productForm(), sb = f && (f.querySelector('[type="submit"][name="add"]') || f.querySelector('[type="submit"]'));
    if (!f) return;
    if (sb && sb.disabled) { doneBtn.textContent = 'Esta opción no está disponible'; setTimeout(updateDone, 2200); return; }
    var go = function (ok) {
      if (!ok) { openUploader(); return; }
      writeProperties();
      var i = document.createElement('input'); i.type = 'hidden'; i.name = 'properties[Fotos]'; i.value = (C && C.NO_PHOTOS.prop) || 'Sin fotos: las enviará por WhatsApp'; i.setAttribute('data-wpfp-prop', '1'); f.appendChild(i);
      adding = true; doneBtn.disabled = true; skipBtn.disabled = true; doneBtn.textContent = 'Agregando…';
      addNow(f, function () { skipBtn.disabled = false; writeProperties(); });
    };
    if (C && C.ask) C.ask(C.NO_PHOTOS).then(go);
    else go(window.confirm('Agregamos tu pedido al carrito sin fotos. Después de tu compra te escribimos por WhatsApp para que nos envíes tus fotos. ¿Continuar?'));
  });
  function openCartDrawer() {
    if (window.updateCartBadges) { try { window.updateCartBadges(); } catch (e) {} }
    if (window.refreshCartDrawer) { try { window.refreshCartDrawer(true); return; } catch (e) {} }
    var dr = $('#CartDrawer');
    if (dr && dr.getAttribute('aria-hidden') === 'false') return;
    var btn = $('.cart-badge-container, [data-cart-drawer-toggle]');
    if (btn) btn.click(); else location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart';
  }
  doneBtn.addEventListener('click', function () {
    if (adding) return;
    if (!state.files.length) { openUploader(); return; }
    var L = layoutFor(currentVariant()), total = L ? L.frames.length : 0, used = state.assign.filter(function (x) { return x != null; }).length;
    if (used < total && !window.confirm((total - used) + (total - used > 1 ? ' cuadros quedan' : ' cuadro queda') + ' sin foto. ¿Agregar al carrito así? Te escribiremos por WhatsApp para completarlo.')) return;
    state.saved = true; state.savedSig = captureSig(); writeProperties(); updateCta(); relabel();
    var f = productForm(), sb = f && (f.querySelector('[type="submit"][name="add"]') || f.querySelector('[type="submit"]'));
    if (!f) return;
    if (sb && sb.disabled) { doneBtn.textContent = 'Esta opción no está disponible'; setTimeout(updateDone, 2200); return; }
    adding = true; doneBtn.disabled = true; doneBtn.textContent = 'Guardando tu vista previa…';
    var sig = captureSig();
    var shot = state.preview && state.preview.sig === sig && state.preview.url ? Promise.resolve(state.preview.url)
      : Promise.race([capture(), new Promise(function (r) { setTimeout(function () { r(null); }, 40000); })]);
    shot.then(function (url) {
      state.preview = url ? { sig: sig, url: url } : null;
      return makePrints();
    }).then(function () {
      writeProperties();
      doneBtn.textContent = 'Agregando…';
      addNow(f);
    });
  });
  /* fotos ajustadas por el cliente: se arma y se sube el archivo final para imprimir (si falla, el pedido igual lleva los ajustes por escrito) */
  function makePrints() {
    var W = PE(), L = layoutFor(currentVariant()); if (!W || !L) return Promise.resolve();
    var jobs = [];
    L.frames.forEach(function (f, i) {
      if (!isEdited(i)) return;
      var sg = printSig(i), pr = state.prints[i]; if (pr && pr.sig === sg && pr.url) return;
      var file = state.files[state.assign[i]], cm = openingCm(f, currentVariant()), e = editFor(i);
      jobs.push(function () {
        return W.uploadPrint(file.url, e, cm.w / cm.h, 'cuadro-' + (i + 1) + '-foto-' + (state.assign[i] + 1) + '-lista-para-imprimir.jpg')
          .then(function (u) { if (u) state.prints[i] = { sig: sg, url: u }; });
      });
    });
    if (!jobs.length) return Promise.resolve();
    doneBtn.textContent = 'Preparando tus fotos para imprimir…';
    return W.pool(jobs, 2, 80000, function (d, t) { doneBtn.textContent = 'Preparando tus fotos ' + d + ' de ' + t + '…'; });
  }
  function addNow(f, after) {
    var fd = new FormData(f);
    $$('[data-img-id] input[name^="properties["]').forEach(function (inp) { if (!f.contains(inp) && inp.name && !fd.has(inp.name)) fd.append(inp.name, inp.value); });
    fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        doneBtn.textContent = '✓ Agregado al carrito';
        setTimeout(function () { adding = false; doneBtn.disabled = false; if (after) after(); updateDone(); closeModal(); openCartDrawer(); }, INLINE ? 900 : 700);
      })
      .catch(function (err) {
        adding = false; doneBtn.disabled = false; if (after) after();
        doneBtn.textContent = (err && err.description) ? String(err.description) : 'No pudimos agregarlo. Inténtalo de nuevo.';
        setTimeout(updateDone, 3200);
      });
  }

  /* ---------- captura para el pedido: lo mismo que vio el cliente, en una imagen ---------- */
  var FRAME_FILL = {
    negro: ['#34343a', '#18181b', '#0f0f11'], blanco: ['#ffffff', '#f1f0ec', '#e2e1dc'],
    madera: ['#e6c9a0', '#d0aa78', '#bf955f'], nogal: ['#835a3d', '#63422c', '#4c3221']
  };
  function captureSig() { var v = currentVariant(); return [v.id, state.assign.join('.'), effectiveMargin(v), state.files.map(function (f) { return f.uuid; }).join('.'), state.assign.map(function (k, i) { return isEdited(i) ? JSON.stringify(editFor(i)) : ''; }).join(',')].join('|'); }
  function capture() {
    var C = window.WPCapture; if (!C || !state.files.length) return Promise.resolve(null);
    var v = currentVariant(), L = layoutFor(v); if (!L) return Promise.resolve(null);
    var color = frameColor(v), margin = effectiveMargin(v), bw = isBW(v);
    var W = 1600, pad = 56, inner = W - pad * 2;
    var R = L.room ? (L.room[color] || L.room.madera || L.room[Object.keys(L.room)[0]]) : null;
    var crop = L.roomCrop || [0, 0, 100, 100];
    var roomH = 0, imgW = 0, imgH = 0;
    if (R) { var ar = R.ar || 1, regionAR = (crop[2] / 100 * ar) / (crop[3] / 100); roomH = inner / regionAR; imgW = inner / (crop[2] / 100); imgH = imgW / ar; }
    var sc = Math.min(inner / L.w, 900 / L.h), compW = L.w * sc, compH = L.h * sc;
    var legend = L.frames.length + L.frames.filter(function (f, i) { return isEdited(i); }).length * 0.8, headH = 170;
    var Hc = headH + (R ? roomH + 46 : 0) + compH + 160 + legend * 34 + 80;
    var urls = L.frames.map(function (f, i) { var k = state.assign[i]; return k != null && state.files[k] ? photoUrl(state.files[k], 1000) : null; });
    if (R) urls.push(R.img + (R.img.indexOf('?') > -1 ? '&' : '?') + 'width=2000');
    return C.loadAll(urls, 5).then(function (imgs) {
      var cv = C.canvas(W, Hc), ctx = cv.getContext('2d');
      ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, W, Hc);
      function drawPhoto(im, i, x, y, w, hh) { var P = PE(); if (P) P.draw(ctx, im, x, y, w, hh, editFor(i) || {}); else C.cover(ctx, im, x, y, w, hh); }
      // encabezado
      ctx.fillStyle = '#16224a'; ctx.font = '700 34px system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif'; ctx.textBaseline = 'top';
      C.wrap(ctx, TITLE, pad, 40, inner, 40, 1);
      ctx.font = '400 22px system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif'; ctx.fillStyle = '#4b5470';
      var det = [v.title && v.title !== 'Default Title' ? v.title : '', 'Marco: ' + (COLOR_NAMES[color] || color), bordeFrom(v) === false ? '' : 'Margen: ' + (margin ? labelForMargin(margin) + ' (' + margin + ' %)' : 'sin margen'), bw ? 'Blanco y negro' : ''].filter(Boolean).join(' · ');
      C.wrap(ctx, det, pad, 88, inner, 28, 2);
      ctx.fillStyle = '#8a90a3'; ctx.font = '400 18px system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif';
      ctx.fillText('Vista previa que aprobó el cliente · ' + C.stamp(), pad, 136);
      var y = headH;
      // en la pared (plantilla con ambiente)
      if (R) {
        var room = imgs[imgs.length - 1];
        ctx.save(); ctx.beginPath(); ctx.rect(pad, y, inner, roomH); ctx.clip();
        if (room) ctx.drawImage(room, pad - crop[0] / 100 * imgW, y - crop[1] / 100 * imgH, imgW, imgH); else C.hatch(ctx, pad, y, inner, roomH);
        L.frames.forEach(function (f, i) {
          var s = R.slots[i]; if (!s) return;
          var x = pad + (s[0] - crop[0]) / 100 * imgW, yy = y + (s[1] - crop[1]) / 100 * imgH, w = s[2] / 100 * imgW, hh = s[3] / 100 * imgH;
          var prof = Math.min(PROFILE_CM, Math.min(f.w, f.h) * 0.12), iw = f.w - 2 * prof, ih = f.h - 2 * prof, m = matWidth(iw, ih, margin) * (w / iw);
          ctx.fillStyle = '#fbfaf7'; ctx.fillRect(x, yy, w, hh);
          var im = imgs[i];
          if (im) { drawPhoto(im, i, x + m, yy + m, w - 2 * m, hh - 2 * m); if (bw) C.gray(ctx, x + m, yy + m, w - 2 * m, hh - 2 * m); }
          else C.hatch(ctx, x + m, yy + m, w - 2 * m, hh - 2 * m);
        });
        ctx.restore();
        y += roomH + 46;
      }
      // a escala, con cada cuadro numerado
      ctx.fillStyle = '#f4f1ec'; ctx.fillRect(pad, y, inner, compH + 80);
      var ox = pad + (inner - compW) / 2, oy = y + 40;
      L.frames.forEach(function (f, i) {
        var x = ox + f.x * sc, yy = oy + f.y * sc, w = f.w * sc, hh = f.h * sc;
        var prof = color === 'none' ? 0 : Math.min(PROFILE_CM, Math.min(f.w, f.h) * 0.12), pr = prof * sc;
        var mat = matWidth(f.w - 2 * prof, f.h - 2 * prof, margin) * sc;
        ctx.save(); ctx.shadowColor = 'rgba(40,30,20,.32)'; ctx.shadowBlur = 18; ctx.shadowOffsetY = 8;
        var fill = FRAME_FILL[color];
        if (fill) { var g = ctx.createLinearGradient(x, yy, x + w, yy + hh); g.addColorStop(0, fill[0]); g.addColorStop(0.58, fill[1]); g.addColorStop(1, fill[2]); ctx.fillStyle = g; }
        else ctx.fillStyle = '#fbfaf7';
        ctx.fillRect(x, yy, w, hh); ctx.restore();
        if (color === 'blanco') { ctx.strokeStyle = 'rgba(0,0,0,.14)'; ctx.lineWidth = 1; ctx.strokeRect(x + 0.5, yy + 0.5, w - 1, hh - 1); }
        ctx.fillStyle = '#fbfaf7'; ctx.fillRect(x + pr, yy + pr, w - 2 * pr, hh - 2 * pr);
        var px = x + pr + mat, py = yy + pr + mat, pw = w - 2 * pr - 2 * mat, ph = hh - 2 * pr - 2 * mat, im = imgs[i];
        if (im) { drawPhoto(im, i, px, py, pw, ph); if (bw) C.gray(ctx, px, py, pw, ph); }
        else C.hatch(ctx, px, py, pw, ph);
        C.badge(ctx, String(i + 1), x + pr + 6, yy + pr + 6, 14);
      });
      y += compH + 80 + 40;
      // leyenda para el taller
      ctx.fillStyle = '#16224a'; ctx.font = '700 22px system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif';
      ctx.fillText('Medida total aprox. ' + fmtCm(L.w) + ' × ' + fmtCm(L.h) + ' cm', pad, y); y += 40;
      ctx.font = '400 20px system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif';
      L.frames.forEach(function (f, i) {
        var k = state.assign[i], file = k != null ? state.files[k] : null;
        ctx.fillStyle = file ? '#3d4152' : '#b4462e';
        C.wrap(ctx, (i + 1) + '. ' + frameLabel(f, i, L) + ' (' + fmtCm(f.w) + '×' + fmtCm(f.h) + ' cm) → ' + (file ? 'Foto ' + (k + 1) + (file.name && !/^[0-9a-f-]{36}\.\w+$/i.test(file.name) ? ' – ' + file.name : '') + (isEdited(i) ? ' · ajustada: ' + PE().describe(editFor(i)) : '') : 'SIN FOTO'), pad, y, inner, 26, 2);
        y += isEdited(i) ? 60 : 34;
      });
      ctx.fillStyle = '#a3a7b5'; ctx.font = '400 16px system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif';
      ctx.fillText('Wolpic · wolpic.com', pad, Hc - 40);
      var slug = String(PRODUCT.handle || 'cuadros').replace(/[^a-z0-9-]/gi, '').slice(0, 40) || 'cuadros';
      return C.upload(cv, 'vista-previa-' + slug + '.jpg');
    }).catch(function () { return null; });
  }

  /* ---------- render ---------- */
  function frameEl(f, i, L, color, marginPct, scale) {
    var el = h('div', 'wpfp-frame wpfp-frame--' + color);
    el.setAttribute('data-frame', i);
    el.setAttribute('role', 'button');
    el.setAttribute('tabindex', '0');
    var prof = color === 'none' ? 0 : Math.min(PROFILE_CM, Math.min(f.w, f.h) * 0.12);
    var innerW = f.w - 2 * prof, innerH = f.h - 2 * prof;
    var mat = matWidth(innerW, innerH, marginPct);
    el.style.padding = (prof * scale) + 'px';
    var k = state.assign[i], file = k != null ? state.files[k] : null;
    var opening = h('div', 'wpfp-open');
    opening.style.padding = (mat * scale) + 'px';
    var photo = h('div', 'wpfp-photo' + (file ? '' : ' is-empty'));
    if (file) {
      var pin = photoInner(file, k, i, Math.max(300, Math.round(Math.max(f.w, f.h) * scale * 2)), Math.min(f.w, f.h) * scale);
      if (pin.bg) photo.style.backgroundImage = 'url("' + pin.bg + '")';
      photo.innerHTML = pin.html;
    } else {
      photo.innerHTML = '<span class="wpfp-plus">+</span>';
    }
    opening.appendChild(photo);
    el.appendChild(opening);
    el.setAttribute('aria-label', frameLabel(f, i, L) + ', ' + fmtCm(f.w) + ' x ' + fmtCm(f.h) + ' cm' + (file ? ', foto ' + (k + 1) : ', sin foto'));
    if (state.selected && state.selected.type === 'frame' && state.selected.idx === i) el.classList.add('is-selected');
    var tag = h('span', 'wpfp-size', fmtCm(f.w) + '×' + fmtCm(f.h));
    el.appendChild(tag);
    return el;
  }

  /* plantilla real: la foto del ambiente con los huecos de cada marco */
  var roomImgs = {};
  function renderRoom(L, color, margin) {
    var stage = $('.wpfp-stage', modal), room = $('.wpfp-room', modal);
    room.innerHTML = '';
    var R = L.room[color] || L.room.madera || L.room[Object.keys(L.room)[0]];
    var crop = L.roomCrop || [0, 0, 100, 100], ar = R.ar || 1;
    var regionAR = (crop[2] / 100 * ar) / (crop[3] / 100);
    var sw = stage.clientWidth || 600, sh = stage.clientHeight || 420;
    var W = Math.min(sw, sh * regionAR), Hh = W / regionAR;
    room.style.width = W + 'px'; room.style.height = Hh + 'px';
    var imgW = W / (crop[2] / 100), imgH = imgW / ar;
    var img = roomImgs[R.img];   // se reutiliza la imagen ya cargada (sin parpadeo al tocar)
    if (!img) { img = roomImgs[R.img] = h('img', 'wpfp-room__img'); img.alt = ''; img.decoding = 'async'; img.src = R.img + (R.img.indexOf('?') > -1 ? '&' : '?') + 'width=' + (window.innerWidth < 900 ? 1200 : 1800); }
    img.style.width = imgW + 'px'; img.style.height = imgH + 'px';
    img.style.left = -(crop[0] / 100 * imgW) + 'px'; img.style.top = -(crop[1] / 100 * imgH) + 'px';
    room.appendChild(img);
    L.frames.forEach(function (f, i) {
      var s = R.slots[i]; if (!s) return;
      var el = h('div', 'wpfp-frame wpfp-frame--slot');
      el.setAttribute('data-frame', i); el.setAttribute('role', 'button'); el.setAttribute('tabindex', '0');
      var x = (s[0] - crop[0]) / 100 * imgW, y = (s[1] - crop[1]) / 100 * imgH, w = s[2] / 100 * imgW, hh = s[3] / 100 * imgH;
      el.style.left = x + 'px'; el.style.top = y + 'px'; el.style.width = w + 'px'; el.style.height = hh + 'px';
      var prof = Math.min(PROFILE_CM, Math.min(f.w, f.h) * 0.12), innerW = f.w - 2 * prof, innerH = f.h - 2 * prof;
      el.style.padding = (matWidth(innerW, innerH, margin) * (w / innerW)) + 'px';
      var k = state.assign[i], file = k != null ? state.files[k] : null;
      var photo = h('div', 'wpfp-photo' + (file ? '' : ' is-empty'));
      if (file) { var pin = photoInner(file, k, i, 700, Math.min(w, hh)); if (pin.bg) photo.style.backgroundImage = 'url("' + pin.bg + '")'; photo.innerHTML = pin.html; }
      else photo.innerHTML = '<span class="wpfp-plus">+</span>';
      el.appendChild(photo);
      if (state.selected && state.selected.type === 'frame' && state.selected.idx === i) el.classList.add('is-selected');
      el.setAttribute('aria-label', frameLabel(f, i, L) + (file ? ', foto ' + (k + 1) : ', sin foto'));
      room.appendChild(el);
    });
  }

  function renderStage() {
    var v = currentVariant(), L = layoutFor(v); if (!L) return;
    var color = frameColor(v), margin = effectiveMargin(v);
    var stage = $('.wpfp-stage', modal), comp = $('.wpfp-comp', modal), single = $('.wpfp-single', modal);
    var multi = L.frames.length > 1;
    stage.classList.toggle('is-bw', isBW(v));
    if (state.view === 'room' && !L.room) state.view = 'set';
    stage.classList.toggle('is-single-view', state.view === 'one' && multi);
    stage.classList.toggle('is-room-view', state.view === 'room');
    comp.innerHTML = ''; single.innerHTML = '';
    if (state.view === 'room') { renderRoom(L, color, margin); }
    else { $('.wpfp-room', modal).innerHTML = ''; }
    // escala para que el conjunto entre en el escenario
    var sw = stage.clientWidth || 600, sh = stage.clientHeight || 420;
    var pad = Math.max(28, Math.min(sw, sh) * 0.1);
    var scale = Math.min((sw - pad * 2) / L.w, (sh - pad * 2) / L.h);
    comp.style.width = (L.w * scale) + 'px';
    comp.style.height = (L.h * scale) + 'px';
    L.frames.forEach(function (f, i) {
      var el = frameEl(f, i, L, color, margin, scale);
      el.style.left = (f.x * scale) + 'px'; el.style.top = (f.y * scale) + 'px';
      el.style.width = (f.w * scale) + 'px'; el.style.height = (f.h * scale) + 'px';
      comp.appendChild(el);
    });
    if (state.view === 'one' && multi) {
      L.frames.forEach(function (f, i) {
        var card = h('div', 'wpfp-one');
        var box = h('div', 'wpfp-one__box');
        var s2 = Math.min(220 / f.w, 260 / f.h, Math.max(60, (stage.clientHeight || 300) - 90) / f.h);
        var el = frameEl(f, i, L, color, margin, s2);
        el.style.width = (f.w * s2) + 'px'; el.style.height = (f.h * s2) + 'px'; el.style.position = 'relative';
        box.appendChild(el); card.appendChild(box);
        card.appendChild(h('p', 'wpfp-one__cap', esc(frameLabel(f, i, L)) + ' · ' + fmtCm(f.w) + '×' + fmtCm(f.h) + ' cm'));
        single.appendChild(card);
      });
    }
    $('.wpfp-measure', modal).textContent = (multi
      ? 'Medida total aprox. ' + fmtCm(L.w) + ' × ' + fmtCm(L.h) + ' cm · ' + L.frames.length + ' cuadros'
      : 'Cuadro de ' + fmtCm(L.w) + ' × ' + fmtCm(L.h) + ' cm') + (isBW(v) ? ' · en blanco y negro' : '');
  }

  function renderViews() {
    var L = layoutFor(currentVariant()), box = $('.wpfp-views', modal);
    box.innerHTML = '';
    var tabs = [];
    if (L && L.room) tabs.push(['room', 'En tu pared']);
    if (L && (L.frames.length > 1 || L.room)) tabs.push(['set', 'A escala']);
    if (L && L.frames.length > 1) tabs.push(['one', 'Uno por uno']);
    if (tabs.length < 2) { box.hidden = true; return; }
    box.hidden = false;
    tabs.forEach(function (o) {
      var b = h('button', 'wpfp-view' + (state.view === o[0] ? ' is-active' : ''), o[1]);
      b.type = 'button'; b.setAttribute('role', 'tab'); b.setAttribute('aria-selected', state.view === o[0]);
      b.addEventListener('click', function () { state.view = o[0]; renderAll(); });
      box.appendChild(b);
    });
  }

  function renderTray() {
    var tray = $('.wpfp-tray', modal), help = $('.wpfp-help', modal);
    var L = layoutFor(currentVariant()), total = L ? L.frames.length : 0;
    tray.innerHTML = '';
    state.files.forEach(function (f, k) {
      var used = state.assign.indexOf(k) > -1;
      var t = h('button', 'wpfp-thumb' + (used ? ' is-used' : '') + (state.selected && state.selected.type === 'file' && state.selected.idx === k ? ' is-selected' : ''));
      t.type = 'button'; t.setAttribute('data-file', k);
      t.setAttribute('aria-label', 'Foto ' + (k + 1) + (used ? ', ya está en un cuadro' : ''));
      t.style.backgroundImage = 'url("' + photoUrl(f, 240) + '")';
      t.innerHTML = '<span class="wpfp-num">' + (k + 1) + '</span>';
      tray.appendChild(t);
    });
    var add = h('button', 'wpfp-add', '<span>+</span>' + (state.files.length ? 'Cambiar / agregar' : 'Subir fotos'));
    add.type = 'button';
    add.addEventListener('click', openUploader);
    tray.appendChild(add);
    var max = maxFiles();
    help.textContent = state.files.length
      ? (total > 1 ? (TOUCH ? 'Toca una foto y luego el cuadro donde va. Para intercambiar, toca un cuadro y luego otro.' : 'Arrastra una foto a un cuadro, o tócala y luego toca el cuadro. Para intercambiar, arrastra un cuadro sobre otro.') : 'Toca otra foto para cambiar la del cuadro.') + (PE() ? ' Con «Editar» en cada cuadro recortas, giras o le pones filtros a la foto.' : '')
      : 'Sube ' + (total > 1 ? 'tus ' + total + ' fotos' : 'tu foto') + (total > 1 ? ' y aparecerán dentro de los marcos.' : ' y aparecerá dentro del marco.');
    help.setAttribute('data-max', max || '');
  }

  function renderColors() {
    var box = $('.wpfp-colors', modal), block = $('.wpfp-block--color', modal);
    var list = availableColors(), cur = frameColor(currentVariant());
    box.innerHTML = '';
    if (!list.length) { block.hidden = true; return; }
    block.hidden = false;
    list.forEach(function (c) {
      var b = h('button', 'wpfp-color' + (c.color === cur ? ' is-active' : ''));
      b.type = 'button';
      b.setAttribute('aria-pressed', c.color === cur);
      b.innerHTML = '<img src="' + esc(DATA.swatches[c.color] || '') + '" alt="" width="44" height="44"><span>' + esc(COLOR_NAMES[c.color] || c.value) + '</span>';
      b.addEventListener('click', function () {
        if (EMB) { var keep = colorValueFor(c.color, bordeFrom(currentVariant())); chooseColor(keep || c.value); }
        else chooseColor(c.value);
      });
      box.appendChild(b);
    });
  }

  function renderMargins() {
    var v = currentVariant(), box = $('.wpfp-margins', modal), note = $('.wpfp-margin-note', modal);
    var block = $('.wpfp-block--margin', modal);
    box.innerHTML = '';
    block.hidden = false;
    var cur = effectiveMargin(v);
    var noSin = (EMB && !colorValueFor(frameColor(v), false)) || (BORDE_IDX > -1 && !optionValue(BORDE_IDX, /sin borde/i));
    MARGINS.forEach(function (m) {
      if (m.pct === 0 && noSin) return;   // este producto siempre lleva borde: no se ofrece "Sin margen"
      var btn = h('button', 'wpfp-margin' + (m.pct === cur ? ' is-active' : ''));
      btn.type = 'button'; btn.setAttribute('aria-pressed', m.pct === cur);
      btn.innerHTML = '<i style="--m:' + (m.pct ? Math.max(2, Math.round(matWidth(10, 10, m.pct) * 2.2)) : 0) + 'px"></i><span>' + m.label + '</span><small>' + m.hint + '</small>';
      btn.addEventListener('click', function () {
        state.margin = m.pct; state.saved = false;
        if (EMB) {   // "Sin margen" = color solo; con margen = "color + borde"
          var wantB = m.pct > 0, val = colorValueFor(frameColor(currentVariant()), wantB);
          if (wantB !== bordeFrom(currentVariant()) && val) { chooseOption(COLOR_IDX, val); return; }
        }
        if (BORDE_IDX > -1) {   // "Sin margen" = variante Sin borde; con margen = Con borde
          var wantSin = m.pct === 0, isSin = bordeFrom(currentVariant()) === false;
          if (wantSin !== isSin) { chooseOption(BORDE_IDX, optionValue(BORDE_IDX, wantSin ? /sin borde/i : /con borde/i)); return; }
        }
        renderAll(); writeProperties();
      });
      box.appendChild(btn);
    });
    box.style.gridTemplateColumns = 'repeat(' + box.children.length + ', minmax(0, 1fr))';
    note.textContent = cur ? 'El margen blanco es igual en los cuatro lados de cada foto.' : 'Sin margen: la foto llena todo el marco.';
  }

  /* barra bajo la vista previa cuando hay un cuadro elegido: editar su foto o intercambiarla */
  function renderAdjbar() {
    var bar = $('.wpfp-adjbar', modal); if (!bar) return;
    var sel = state.selected, i = sel && sel.type === 'frame' ? sel.idx : -1, k = i > -1 ? state.assign[i] : null;
    if (i < 0 || k == null || !PE()) { bar.hidden = true; bar.innerHTML = ''; return; }
    var L = layoutFor(currentVariant()), multi = L && L.frames.length > 1;
    bar.hidden = false;
    bar.innerHTML = '<div class="wpfp-adjbar__t"><strong>' + esc(frameLabel(L.frames[i], i, L)) + ' · foto ' + (k + 1) + '</strong><small>' +
      (isEdited(i) ? 'Ajustada: ' + esc(PE().describe(editFor(i))) : 'Recórtala, gírala, enderézala o ponle un filtro') + (multi ? ' · o toca otro cuadro para intercambiarlas' : '') + '</small></div>' +
      '<button type="button" class="wpfp-adjbar__edit" data-edit="' + i + '">' + PE().ICON.edit + 'Editar foto</button>' +
      '<button type="button" class="wpfp-adjbar__x" data-unselect aria-label="Cerrar">✓</button>';
  }
  function renderStatus() {
    var L = layoutFor(currentVariant()), total = L ? L.frames.length : 0;
    var used = state.assign.filter(function (x) { return x != null; }).length;
    var s = $('.wpfp-status', modal);
    if (!state.files.length) s.textContent = 'Aún no subiste fotos: súbelas ahora o envíalas por WhatsApp después de comprar.';
    else if (used < total) s.textContent = used + ' de ' + total + ' cuadros con foto. Puedes subir más fotos o agregar así.';
    else {
      var extra = state.files.length - used;
      s.textContent = '¡Todos tus cuadros tienen foto!' + (extra > 0 ? ' ' + extra + (extra > 1 ? ' fotos subidas no se usan.' : ' foto subida no se usa.') : '');
    }
    $('.wpfp-price', modal).textContent = money(currentVariant().price);
    updateDone();
  }

  /* opción 2 (la ficha es el personalizador): las demás opciones del producto (paquete, tamaño, efecto) se eligen aquí */
  function renderOpts() {
    var block = $('.wpfp-block--opts', modal), box = $('.wpfp-opts', modal);
    if (!block) return;
    box.innerHTML = '';
    if (!INLINE) { block.hidden = true; return; }
    var v = currentVariant(), any = false;
    PRODUCT.options.forEach(function (o, idx) {
      if (idx === COLOR_IDX || idx === BORDE_IDX) return;
      var vals = []; PRODUCT.variants.forEach(function (x) { if (vals.indexOf(x.options[idx]) < 0) vals.push(x.options[idx]); });
      if (vals.length < 2) return;
      any = true;
      var row = h('div', 'wpfp-optrow', '<p class="wpfp-optname">' + esc(o.name || o) + '</p>');
      var list = h('div', 'wpfp-optvals');
      vals.forEach(function (val) {
        var b = h('button', 'wpfp-optval' + (v.options[idx] === val ? ' is-active' : ''), esc(val));
        b.type = 'button'; b.setAttribute('aria-pressed', v.options[idx] === val);
        b.addEventListener('click', function () { if (v.options[idx] !== val) chooseOption(idx, val); });
        list.appendChild(b);
      });
      row.appendChild(list); box.appendChild(row);
    });
    block.hidden = !any;
  }

  function renderAll() {
    if (!modal.parentNode) return;
    var ae = document.activeElement, sel = null;
    if (ae && modal.contains(ae)) {
      if (ae.hasAttribute('data-frame')) sel = '.wpfp-frame[data-frame="' + ae.getAttribute('data-frame') + '"]';
      else if (ae.hasAttribute('data-file')) sel = '.wpfp-thumb[data-file="' + ae.getAttribute('data-file') + '"]';
    }
    renderOpts(); renderViews(); renderStage(); renderTray(); renderColors(); renderMargins(); renderStatus(); renderAdjbar();
    if (PE()) { PE().applyAll(modal); markQuality(); }
    if (sel) { var t = $$(sel, modal).filter(function (el) { return el.offsetParent !== null; })[0]; if (t) try { t.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* ---------- asignar fotos: tocar o arrastrar ---------- */
  function assignFileToFrame(fileIdx, frameIdx) {
    var prev = state.assign.indexOf(fileIdx);
    var current = state.assign[frameIdx];
    if (prev > -1) { state.assign[prev] = current != null ? current : null; swapEdits(prev, frameIdx); } // si la foto estaba en otro cuadro, intercambia (con sus ajustes)
    state.assign[frameIdx] = fileIdx;
    state.saved = false;
  }
  function swapFrames(a, b) {
    var t = state.assign[a]; state.assign[a] = state.assign[b]; state.assign[b] = t; swapEdits(a, b); state.saved = false;
  }
  function handleTapFrame(i) {
    var sel = state.selected;
    if (sel && sel.type === 'file') { assignFileToFrame(sel.idx, i); state.selected = null; }
    else if (sel && sel.type === 'frame') {
      if (sel.idx === i && state.assign[i] != null && PE()) { openFrameEditor(i); return; }   // segundo toque: abre el editor
      if (sel.idx !== i) swapFrames(sel.idx, i); state.selected = null;
    }
    else if (state.assign[i] != null) { state.selected = { type: 'frame', idx: i }; }
    else {
      var unused = -1;
      state.files.forEach(function (f, k) { if (unused < 0 && state.assign.indexOf(k) < 0) unused = k; });
      if (unused > -1) assignFileToFrame(unused, i); else openUploader();
    }
    writeProperties(); renderAll();
  }
  function handleTapFile(k) {
    var Lt = layoutFor(currentVariant());
    if (Lt && Lt.frames.length === 1) { assignFileToFrame(k, 0); state.selected = null; writeProperties(); renderAll(); return; }
    if (state.selected && state.selected.type === 'file' && state.selected.idx === k) state.selected = null;
    else if (state.selected && state.selected.type === 'frame') { assignFileToFrame(k, state.selected.idx); state.selected = null; writeProperties(); }
    else state.selected = { type: 'file', idx: k };
    renderAll();
  }

  var drag = null;
  modal.addEventListener('pointerdown', function (e) {
    if (e.target.closest('[data-edit], [data-unselect], .wpfp-adjbar')) return;
    var thumb = e.target.closest('.wpfp-thumb'), frame = e.target.closest('.wpfp-frame');
    if (!thumb && !frame) return;
    var src = thumb ? { type: 'file', idx: +thumb.getAttribute('data-file') } : { type: 'frame', idx: +frame.getAttribute('data-frame') };
    if (src.type === 'frame' && state.assign[src.idx] == null) { drag = { src: src, x: e.clientX, y: e.clientY, moved: false, tapOnly: true }; return; }
    var fileIdx = src.type === 'file' ? src.idx : state.assign[src.idx];
    drag = { src: src, x: e.clientX, y: e.clientY, moved: false, url: photoUrl(state.files[fileIdx], 200) };
  });
  modal.addEventListener('pointermove', function (e) {
    if (!drag || drag.tapOnly) return;
    var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
    if (!drag.moved && Math.sqrt(dx * dx + dy * dy) < 8) return;
    var ghost = $('.wpfp-ghost', modal);
    if (!drag.moved) {
      drag.moved = true;
      ghost.style.backgroundImage = 'url("' + drag.url + '")';
      ghost.classList.add('is-on');
      modal.classList.add('is-dragging');
    }
    e.preventDefault();
    ghost.style.transform = 'translate(' + (e.clientX - 36) + 'px,' + (e.clientY - 36) + 'px)';
    $$('.wpfp-frame.is-over', modal).forEach(function (n) { n.classList.remove('is-over'); });
    var under = document.elementFromPoint(e.clientX, e.clientY), fr = under && under.closest('.wpfp-frame');
    if (fr) fr.classList.add('is-over');
  });
  function endDrag(e) {
    if (!drag) return;
    var d = drag; drag = null;
    var ghost = $('.wpfp-ghost', modal); ghost.classList.remove('is-on');
    modal.classList.remove('is-dragging');
    $$('.wpfp-frame.is-over', modal).forEach(function (n) { n.classList.remove('is-over'); });
    if (!d.moved) {
      if (d.src.type === 'file') handleTapFile(d.src.idx); else handleTapFrame(d.src.idx);
      return;
    }
    var under = document.elementFromPoint(e.clientX, e.clientY), fr = under && under.closest('.wpfp-frame');
    if (!fr) return;
    var target = +fr.getAttribute('data-frame');
    if (d.src.type === 'file') assignFileToFrame(d.src.idx, target); else if (d.src.idx !== target) swapFrames(d.src.idx, target);
    state.selected = null;
    writeProperties(); renderAll();
  }
  modal.addEventListener('pointerup', endDrag);
  document.addEventListener('pointerup', function (e) { if (drag && !modal.contains(e.target)) endDrag(e); });
  modal.addEventListener('pointercancel', function () { drag = null; $('.wpfp-ghost', modal).classList.remove('is-on'); modal.classList.remove('is-dragging'); });
  modal.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    if (e.target.closest && e.target.closest('[data-edit], [data-unselect]')) return;
    var fr = e.target.closest && e.target.closest('.wpfp-frame'), th = e.target.closest && e.target.closest('.wpfp-thumb');
    if (fr) { e.preventDefault(); handleTapFrame(+fr.getAttribute('data-frame')); }
    else if (th) { e.preventDefault(); handleTapFile(+th.getAttribute('data-file')); }
  });

  /* re-render al cambiar tamaño o variante */
  var rt;
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(renderAll, 120); });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'id') { setTimeout(function () { setFiles(state.files.slice()); renderAll(); writeProperties(); updateCta(); }, 30); }
  }, true);
  var lastVid = String(currentVariant().id), lastCount = (layoutFor(currentVariant()) || { frames: [] }).frames.length;
  function syncVariant() {
    var v = currentVariant(), id = String(v.id);
    if (id === lastVid) return;
    var n = (layoutFor(v) || { frames: [] }).frames.length;
    if (n !== lastCount) state.saved = false;   // cambió la cantidad de cuadros: hay que volver a armar la vista previa
    lastVid = id; lastCount = n;
    setFiles(state.files.slice()); renderAll(); writeProperties(); updateCta(); relabel();
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.product-option-group [data-value], .product-options-container [data-value], variant-selects, .sticky-variant')) {
      setTimeout(syncVariant, 60); setTimeout(syncVariant, 300);
    }
  }, true);
  document.addEventListener('change', function () { setTimeout(syncVariant, 60); }, true);
  var form0 = productForm(), idInput = form0 && form0.querySelector('[name="id"]');
  if (idInput && window.MutationObserver) {
    new MutationObserver(function () { setFiles(state.files.slice()); renderAll(); writeProperties(); updateCta(); })
      .observe(idInput, { attributes: true, attributeFilter: ['value'] });
  }

  /* ---------- montar el CTA debajo del cargador de fotos ---------- */
  function mount() {
    var dom = filesFromDom(); if (dom.length) setFiles(dom);
    if (INLINE) {
      // la ficha es el personalizador: ocupa el lugar de la galería y la columna de compra (el formulario sigue en la página, oculto)
      var grid = $('.product-main-grid');
      var host = grid ? grid.parentNode : root.parentNode;
      modal.classList.add('wpfp-modal--inline', 'is-open');
      $('.wpfp-eyebrow', modal).textContent = (layoutFor(currentVariant()) || { frames: [] }).frames.length > 1 ? 'Diseña tu conjunto' : 'Diseña tu cuadro';
      $('.wpfp-title', modal).textContent = PRODUCT.title;
      host.insertBefore(modal, grid || null);
      if (grid) grid.classList.add('wpfp-hide-grid');
      renderAll();
      var navT = 0;
      var navFix = function () {
        navT = 0;
        var nav = $('.mobile-sticky-navigation'), off = 0;
        if (nav && getComputedStyle(nav).display !== 'none') { var r = nav.getBoundingClientRect(); if (r.height && r.top < window.innerHeight) off = Math.max(0, window.innerHeight - r.top); }
        modal.style.setProperty('--wpfp-nav', off + 'px');
      };
      var navQ = function () { if (!navT) navT = requestAnimationFrame(navFix); };
      window.addEventListener('scroll', navQ, { passive: true });
      window.addEventListener('resize', navQ);
      navFix(); setTimeout(navFix, 800);
      return;
    }
    // la invitación va arriba, justo debajo del precio
    var anchor = $('.product-pricing') || $('[id*="uploadly_file_upload"]') || $('.wp-upload');
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(cta, anchor.nextSibling);
    else root.parentNode.insertBefore(cta, root);
    // el color y el margen se eligen en la ficha (y llegan preseleccionados al personalizador);
    // el cargador de fotos y la guía de pasos quedan dentro del personalizador (siguen en la página, ocultos, para que funcionen)
    $$('[id*="uploadly_file_upload"], .wp-upload').forEach(function (n) { n.classList.add('wpfp-hide-grid'); });
    updateCta();
    relabel();
    watchLabels();
  }

  /* el botón "Añadir al carrito" dice "Personalizar y añadir al carrito" hasta que el cliente arme su vista previa */
  var LABEL_TODO = 'Personaliza tu foto para añadir al carrito', LABEL_TODO_N = 'Personaliza tus fotos para añadir al carrito', relabeling = false;
  function labelTodo() { var L = layoutFor(currentVariant()); return L && L.frames.length > 1 ? LABEL_TODO_N : LABEL_TODO; }
  function atcLabels() {
    return $$('#ProductAddToCartBtn .btn-text, #StickyAddToCart [type="submit"] .btn-text, #StickyAddToCart [type="submit"] span:not([class*="spinner"]):not(:empty)')
      .filter(function (el, i, arr) { return arr.indexOf(el) === i && !el.querySelector('*'); });
  }
  function relabel() {
    if (INLINE) return;
    relabeling = true;
    atcLabels().forEach(function (el) {
      var btn = el.closest('button'), txt = el.textContent.trim();
      if (txt && txt !== LABEL_TODO && txt !== LABEL_TODO_N) el.setAttribute('data-wpfp-label', txt);
      var orig = el.getAttribute('data-wpfp-label') || 'Añadir al carrito';
      var soldOut = btn && btn.disabled;
      var want = isSaved() || soldOut ? orig : labelTodo();
      if (el.textContent !== want) el.textContent = want;
    });
    relabeling = false;
  }
  function watchLabels() {
    if (!window.MutationObserver) return;
    var mo = new MutationObserver(function () { if (!relabeling) setTimeout(relabel, 0); });
    atcLabels().forEach(function (el) { mo.observe(el, { childList: true, characterData: true, subtree: true }); var b = el.closest('button'); if (b) mo.observe(b, { attributes: true, attributeFilter: ['disabled'] }); });
  }

  /* "Añadir al carrito" y "Comprar ahora" de la ficha (y de la barra fija): si el cliente aún no armó su vista previa, abren el personalizador */
  if (!INLINE) {
    document.addEventListener('click', function (e) {
      if (modal.contains(e.target)) return;
      var t = e.target.closest && e.target.closest('[type="submit"], .shopify-payment-button');
      var fm = t && t.closest('form'), sticky = fm && fm.getAttribute('id') === 'sticky-product-form';
      if (!t || (fm !== productForm() && !sticky)) return;
      if (!$('[id*="uploadly_file_upload"]')) { writeProperties(); return; }
      if (isSaved() && !sticky) { writeProperties(); return; }
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      if (isSaved()) {   // la barra fija no lleva el diseño: se agrega con el formulario principal
        writeProperties();
        var sb = productForm() && productForm().querySelector('[type="submit"][name="add"]');
        if (sb) sb.click();
        return;
      }
      openModal();
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount); else mount();
  window.WolpicFramePreview = { open: openModal, state: state, capture: capture, edit: openFrameEditor, prints: makePrints, setFiles: function (l) { setFiles(l); renderAll(); updateCta(); writeProperties(); } };
})();
